import { combineReducers } from 'redux';
import types from 'actions/Types';
import analytics from './Analytics';

import config from 'config';

function storeSearchForm() {
    let header = document.getElementsByTagName('header')[0];

    return JSON.parse(header.getAttribute('data-json'));
}

const globalState = (state = { headerChangeStoreOpen: false, globalSearchVisibility: true }, action) => {
    switch (action.type) {
        case types.SET_USER_LOCATION:
            localStorage.setItem(
                config.localStorageId,
                JSON.stringify({ ...state, uLat: action.uLat, uLng: action.uLng })
            );
            return { ...state, uLat: action.uLat, uLng: action.uLng };
        case types.SUBMIT_REQUEST:
            return { ...state, isLoading: true };
        case types.COMPLETE_REQUEST:
            return { ...state, isLoading: false };
        case types.ADD_STORE_DETAILS:
            return {
                ...state,
                stores: [...state.stores, action.store]
                //myStore: action.store.isMystore ? action.store.id : state.myStore
            };
        case types.SET_SELECTED_STORE:
            return {
                ...state,
                selectedStore: action.id
            };
        default:
            state.storeSearchForm = storeSearchForm();
            return state;
    }
};

const rootReducer = combineReducers({ globalState });

export { analytics, rootReducer };
